import PortalIdParser from 'PortalIdParser';
import { stringify } from 'hub-http/helpers/params';
export function getLivePreviewHref(article, articleLayoutId) {
  const {
    values: {
      hs_preview_key: previewKey,
      hs_absolute_url: absoluteUrl,
      hs_id: articleId
    }
  } = article;
  if (!previewKey) {
    return absoluteUrl;
  }
  const query = stringify({
    hs_preview: `${previewKey}-${articleLayoutId !== null && articleLayoutId !== void 0 ? articleLayoutId : articleId}`
  });
  return `${absoluteUrl}?${query}`;
}
export function getPreviewOrigin(previewDomain) {
  return `${document.location.protocol}//${previewDomain || window.hsPreviewDomain}`;
}
export function getKnowledgeBasePreviewUrl(templatePath, language, knowledgeBaseId) {
  const queryParams = {
    buffer_theme: true,
    language,
    path: templatePath,
    portalId: PortalIdParser.get(),
    preview_theme: true,
    // indicates to use preview/buffer data
    content_group_id: knowledgeBaseId
  };

  // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
  return `${getPreviewOrigin()}/_hcms/preview/template/multi?${stringify(queryParams)}`;
}